import React, { Component, Fragment } from 'react';
import plural from 'pluralize';
import { Card } from 'reactstrap';
import numberToWords from 'number-to-words';
import capitalize from 'capitalize';
import TankTypeText from '~/components/tankTypeText/tankTypeText';
import Icon from '~/components/icon/icon';

export default class TransferScheduleTransfers extends Component {
  renderAfterDays = days => {
    return `after ${days} ${plural('day', days)}`;
  };

  renderRequiresDutyPaid = ({ requiresDutyPaid }) => {
    if (!requiresDutyPaid) {
      return null;
    }
    return <p>This step requires duty paid on the lot before it can be completed</p>;
  };

  renderTank = ({ tankType, tank, days }) => {
    let nameText = '';
    if (['BRITE_TANK', 'UNI_TANK'].indexOf(tankType) !== -1 && tank) {
      nameText = <strong> {tank.name}</strong>;
    }

    return (
      <p>
        Transfer to{' '}
        <em>
          <TankTypeText type={tankType} />
          {nameText}
        </em>{' '}
        {this.renderAfterDays(days)}
      </p>
    );
  };

  renderVessel = ({ vesselDescription, days }) => {
    return (
      <p>
        Transfer to vessels <em>{vesselDescription}</em> {this.renderAfterDays(days)}
      </p>
    );
  };

  renderLocation = ({ location: { name }, days }) => {
    return (
      <p>
        Transfer to <em>{name}</em> {this.renderAfterDays(days)}
      </p>
    );
  };

  renderDryHop = ({ days }) => {
    return <p>Dry hop {this.renderAfterDays(days)}</p>;
  };

  renderClarification = ({ days }) => {
    return <p>Add clarification {this.renderAfterDays(days)}</p>;
  };

  renderIcon = type => {
    switch (type) {
      case 'TANK':
        return <Icon icon="tank" className="stroke-divider" />;
      case 'VESSEL':
        return <Icon icon="wine-barrel" className="stroke-divider" />;
      case 'LOCATION':
        return <Icon icon="shelf" className="stroke-divider" />;
      case 'DRY_HOP':
        return <Icon icon="plant" className="stroke-divider" />;
      case 'CLARIFICATION':
        return <Icon icon="sparkle" className="stroke-divider" />;
      default:
        return <Icon icon="question-circle" className="stroke-divider" />;
    }
  };

  renderTransfer = transfer => {
    return (
      <Card key={transfer.id} className="pa3 mb4">
        <h4 className="h5 h-auto">
          {capitalize(numberToWords.toWords(transfer.stepNumber))} - {transfer.name}
        </h4>
        {transfer.shouldAutocomplete && <p className="ma0 f6 subtext">This step will autocomplete.</p>}
        <div className="flex mt2">
          <div className="mr3">{this.renderIcon(transfer.type)}</div>
          <div className="flex-grow-1">
            {transfer.type === 'TANK' && this.renderTank(transfer)}
            {transfer.type === 'VESSEL' && this.renderVessel(transfer)}
            {transfer.type === 'LOCATION' && this.renderLocation(transfer)}
            {transfer.type === 'DRY_HOP' && this.renderDryHop(transfer)}
            {transfer.type === 'CLARIFICATION' && this.renderClarification(transfer)}
            {this.renderRequiresDutyPaid(transfer)}
            {transfer.notes && transfer.notes.length && <p>Notes: {transfer.notes}</p>}
          </div>
        </div>
      </Card>
    );
  };

  render() {
    const { transfers } = this.props;
    return <Fragment>{transfers.map(this.renderTransfer)}</Fragment>;
  }
}



// WEBPACK FOOTER //
// ./src/components/transferScheduleTransfers/transferScheduleTransfers.jsx